import React from 'react';
import Header from './Header';
import NotificationContainer from './NotificationContainer';

/**
 * Main layout component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components
 */
function Layout({ children }) {
  return (
    <div className='min-h-screen bg-gray-100 p-5'>
      <div className='max-w-4xl mx-auto'>
        <Header />
        {children}
      </div>
      <NotificationContainer />
    </div>
  );
}

export default Layout;
